export const homeObjOne8 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    headline: 'Eventflorist',
    headline2: 'Eventteknik & Atmosfär',
    headline3: 'Eventfotograf',
    description: 'Våra blomsterdesigners skapar exklusiva och skräddarsydda arrangemang som förvandlar varje miljö till något extraordinärt. Med elegans, kreativitet och känsla för detaljer skapar vi blomsterdesign som ger ert event en unik och oförglömlig karaktär.',
    description2: 'Tillsammans med noggrant utvalda partners skapar vi förstklassiga tekniska och visuella lösningar som lyfter ert event till nästa nivå. Med professionellt ljud, stämningsfull ljussättning och modern bildteknik skapar vi en genomtänkt helhetsupplevelse där varje detalj samspelar perfekt.',
    description3: 'Fånga känslan, detaljerna och de ögonblick som gör ert event unikt. Tillsammans med våra noggrant utvalda fotografer skapar vi tidlösa och exklusiva bilder som förevigar allt från de stora ögonblicken till de subtila detaljerna – minnen att bära med sig långt efter att festen är över.',
    img: require('../../AssetsForService/ServiceBlommor.jpg'),
    img2: require('../../AssetsForService/ServiceLight.jpg'),
    img3: require('../../AssetsForService/ServiceCamera.jpg'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}